<template>
  <tdhvp-doc-out-index-common
    :listFn="options => this.list(options)"
    @viewDetail="viewDetail"
  ></tdhvp-doc-out-index-common>
</template>

<script>
import { vbOutgoingDocUserTdhvpViewService } from "../../../services/tdhvp/vbOutgoingDocUserTdhvpViewService";
import TdhvpDocOutIndexCommon from "./tdhvp-doc-out-index-common";

export default {
  name: "tdhvp-doc-out-index",
  components: {
    TdhvpDocOutIndexCommon
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  methods: {
    viewDetail({ item }) {
      this.$router.push({
        name: "tdhvpDocOutDetail",
        params: { id: item.docId, userDeptRoleId: this.userDeptRoleId },
        query: this.$route.query
      });
    },

    list({ form, pageable }) {
      return vbOutgoingDocUserTdhvpViewService
        .findAll(form, pageable)
        .then(response => response.data);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/thdvp/doc-out/tdhvp-doc-out-index.vue